export const SET_COUNTERS = 'setCounters'
